// extracted by mini-css-extract-plugin
module.exports = {"center":"Spinner_center__tRkui","root":"Spinner_root__gNkgf","rotate":"Spinner_rotate__Ekhw6","loadingSpinner":"Spinner_loadingSpinner__UpOMB"};